module.exports = __webpack_public_path__ + "static/media/logo.f69bdf90.png";